import { TextField } from '@origin-digital/style-guide';
import React from 'react';
import analytics from '../../../../analytics';

import { isFieldTouched } from '../../../../utils/formHelpers';

import { TextFieldAdapterProps } from './TextFieldAdapter.types';

export class TextFieldAdapter extends React.Component<TextFieldAdapterProps, {}> {
  constructor(props: TextFieldAdapterProps) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.handleKeyUp = this.handleKeyUp.bind(this);
  }

  componentDidMount() {
    const { field, form } = this.props;

    if (field.value !== '') {
      form.setFieldTouched(field.name, true, true);
    }
  }

  handleKeyUp(event: React.KeyboardEvent<HTMLInputElement>) {
    const { field, form, isInitialValid, changeHandler } = this.props;
    const TAB_KEY = 9;

    if (isInitialValid && event.currentTarget.value === '' && event.keyCode !== TAB_KEY) {
      form.setFieldValue(field.name, event.currentTarget.value);
      form.setFieldTouched(field.name, true, true);

      if (changeHandler) {
        changeHandler({ [field.name]: '' });
      }
    }
  }

  handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    const { field, form, changeHandler } = this.props;

    form.setFieldValue(field.name, event.currentTarget.value);

    if (changeHandler) {
      changeHandler({ [field.name]: event.currentTarget.value });
    }
  };

  render() {
    const { field, form, label, maxLength, transform, helpText } = this.props;

    return (
      <TextField
        data-lpignore={true}
        name={field.name}
        value={field.value}
        label={label}
        //@ts-ignore
        error={form.errors[field.name]}
        maxLength={maxLength}
        transform={transform}
        helpText={helpText}
        onBlur={field.onBlur}
        onKeyUp={e => this.handleKeyUp(e)}
        onChange={e => this.handleChange(e)}
        //@ts-ignore
        touched={isFieldTouched(form, field.name)}
        onClick={() => {
          analytics.firstInteraction();
        }}
      />
    );
  }
}

export { TextFieldAdapter as default };
